import { useMutation, useQuery } from '@tanstack/react-query'

import type { VerifyPromoCodeRequest, VerifyPromoCodeResponse } from '../types/payment.js'

import { apiClient } from '../lib/client.js'
import { resolveInsurancePaymentRequest } from './insurance-payment-request.js'

export const useDecryptAxeptaData = (data?: string, len?: string) =>
  useQuery({
    enabled: !!data && !!len,
    queryFn: async () => {
      const response = await apiClient.client.get<Record<string, string>>(
        '/payment/axepta-decrypt',
        { params: { Data: data, Len: len } }
      )
      return response.data
    },
    queryKey: ['axepta-decrypt', data, len],
    retry: false,
  })

interface InitiateInsurancePaymentResponse {
  axeptaRedirectUrl: string
}

export const useInitiateInsurancePaymentMutation = () =>
  useMutation({
    mutationFn: async ({ bookingId, sessionId }: { bookingId?: string; sessionId?: string }) => {
      const request = resolveInsurancePaymentRequest({ bookingId, sessionId })

      if (!request) {
        throw new Error('Aucun contexte sécurisé disponible pour initier le paiement assurance.')
      }

      const response = await apiClient.client.post<InitiateInsurancePaymentResponse>(
        request.url,
        request.payload
      )
      return response.data
    },
  })

export const useVerifyPromoCode = () =>
  useMutation({
    mutationFn: async ({ code }: VerifyPromoCodeRequest) => {
      const response = await apiClient.client.post<VerifyPromoCodeResponse>(
        `/payment/verify-promo-code/${code}`
      )
      return response.data
    },
  })
